(function() {
  function initLuxuryLogoScroller() {
    const scrollerSections = document.querySelectorAll('.luxury-logo-scroller');
    
    scrollerSections.forEach(section => {
      const track = section.querySelector('.js-lls-track');
      if (!track || track.children.length === 0) return;
      
      // Stop execution context if already cloned within live editor states
      if (track.getAttribute('data-cloned') === 'true') return;

      const initialLogos = Array.from(track.children);
      
      // FIXED: Smart multiplier backfills layout row dynamically to ensure a continuous stream for short lists (e.g. 4 items)
      const repeatCount = initialLogos.length <= 4 ? 4 : 2;

      for (let i = 0; i < repeatCount; i++) {
        initialLogos.forEach(logoItem => {
          const clonedLogo = logoItem.cloneNode(true);
          track.appendChild(clonedLogo);
        });
      }

      // Tag tracker status complete flag
      track.setAttribute('data-cloned', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', initLuxuryLogoScroller);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initLuxuryLogoScroller);
  }
})();